import React, { useState } from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';

import { TabPanel } from 'shared';

import { LLMSearchManagement } from './llmSearchManagement';
import { SearchCompare } from './searchCompare';
import { VectorSearchManagement } from './vectorSearchManagement';

function SearchConfig() {
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab id="llmSearchManagement_Tab" label="Manage LLM Search" value="0" />
                <Tab id="searchCompare_Tab" label="Search Compare" value="1" />
                <Tab id="vectorSearchManagement_Tab" label="Vector Search Management" value="2" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <LLMSearchManagement />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <SearchCompare />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="2">
                <VectorSearchManagement />
            </TabPanel>
        </Paper>
    );
}

export { SearchConfig };
